import { SchemaSection } from '@rossum/api-client/schemas';
import { SchemaFieldIcon } from '@rossum/components/schema-field-icon/SchemaFieldIcon';
import { VariableCompletion } from '@rossum/components/variable-suggestions/types';
import {
  getNonTupleSchemaFields,
  isValidFieldId,
} from './FormulaEditor/helpers';
import { resolveIconType } from './FormulaPreview/hooks/utils';

// TODO: We might or might not have two different `getFieldCompletions` helpers (one for editor, another for suggester)
// Unify?
export const getFieldCompletions = (
  schemaContent: SchemaSection[]
): VariableCompletion[] => {
  return getNonTupleSchemaFields(schemaContent)
    .flatMap(schemaItem =>
      schemaItem.category !== 'section' ? [schemaItem] : []
    )
    .filter(({ id }) => (id ? isValidFieldId(id) : false))
    .map(field => {
      const type = resolveIconType(field);

      return {
        caption: field.label,
        value: field.id,
        score: 1,
        meta: 'field',
        description: field.description ?? '',
        section: field.section,
        renderIcon: type
          ? () => {
              return <SchemaFieldIcon type={type} fontSize="medium" />;
            }
          : undefined,
      };
    });
};
